import Apimanager from "./axios";

export const getIndustryTypes = async () => {
  const res = await Apimanager.get("/misc/industries");
  return res.data;
};
